module.exports = __webpack_public_path__ + "img/left-v3.24120892.svg";